import { render, staticRenderFns } from "./Bens.vue?vue&type=template&id=16e54768"
import script from "./Bens.vue?vue&type=script&lang=js"
export * from "./Bens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports